import { render } from "./PageFormPernyataanOrangTua.vue?vue&type=template&id=4400bcd3"
import script from "./PageFormPernyataanOrangTua.vue?vue&type=script&lang=js"
export * from "./PageFormPernyataanOrangTua.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__